import React, { useState } from 'react'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import { twMerge } from 'tailwind-merge'
import TooltipMaterial, { TooltipProps as TooltipMaterialProps } from '@mui/material/Tooltip'
import ButtonBase from '@mui/material/ButtonBase'

import Platform from 'utils/Platform'

const TOOLTIPCLICK_POPPER_PROPS = {
  disablePortal: true
}

export type TooltipProps = TooltipMaterialProps

const TooltipWithClick: React.FC<TooltipProps> = props => {
  const { children, className, placement, title, PopperProps, ...restProps } = props
  const [open, setOpen] = useState(false)

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const toggleTooltipOpen = () => {
    setOpen(prev => !prev)
  }

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div className={twMerge('inline-flex', className)}>
        <TooltipMaterial
          {...restProps}
          // placement={placement || 'bottom'}
          PopperProps={
            PopperProps
              ? { ...TOOLTIPCLICK_POPPER_PROPS, ...PopperProps }
              : TOOLTIPCLICK_POPPER_PROPS
          }
          onClose={handleTooltipClose}
          open={open}
          title={title}
          disableFocusListener
          disableHoverListener
          disableTouchListener
        >
          <ButtonBase onClick={toggleTooltipOpen}>{children}</ButtonBase>
        </TooltipMaterial>
      </div>
    </ClickAwayListener>
  )
}

const Tooltip: React.FC<
  TooltipProps & {
    trigger?: 'click'
  }
> = props => {
  const { disableInteractive = true, placement, trigger, ...restProps } = props
  const isControlled = typeof props.open !== 'undefined'

  if (!isControlled && (trigger === 'click' || (!trigger && Platform.isTouchDevice())))
    return (
      <TooltipWithClick
        {...restProps}
        disableInteractive={disableInteractive}
        placement={placement}
      />
    )

  return (
    <TooltipMaterial {...restProps} disableInteractive={disableInteractive} placement={placement} />
  )
}

export default Tooltip
